import Cookies from "js-cookie";

function checkCookies(cookie) {
  return cookie && cookie !== "undefined" && cookie !== "null";
}

function state() {
  return {
    callRefreshToken: null,
    userData: checkCookies(Cookies.get("u"))
      ? JSON.parse(Cookies.get("u"))
      : null,
    userOtpData: null,
    userToken: Cookies.get("t") || null,
    userTokenRefresh: Cookies.get("r") || null,
    userOrganizations: [],
    emailActivation: "",
  };
}

export default state;
